import Sortable from 'sortablejs';

const FormBuilder = class {
    options: any
    dropzone: any
    elements: any
    lists: any
    clone: any
    element: any
    opacity: any
    leftSortable: any
    dropzoneSortables: any
    constructor(listContainer: any, options: any){
        this.options = options;
        this.dropzone = options.dropzone;
        this.elements = [];
        this.clone = null;
        this.opacity = 1;

        this.leftSortable = new Sortable(listContainer, {
            group: {
                name: 'shared',
                pull: 'clone',
                put: false // Do not allow items to be put into this list
            },
            animation: 150,
            sort: false, // To disable sorting: set sort to false
            handle: options.handle,
            ...options.events
        });
        this.setDropZones();
    }
    addStep(){
        this.dropzoneSortables.map((sortable) => {
            sortable.destroy();
        });
        this.setDropZones();
    }
    setDropZones(){
        const options = this.options;
        const dropzones = document.querySelectorAll(this.dropzone);
        const dropzoneSortables = [];
        dropzones.forEach((item) => {
            const rightSortable = new Sortable(item, {
                group: 'shared',
                animation: 150,
                handle: options.handle,
                ...options.events
            });
            dropzoneSortables.push(rightSortable);
        });
        this.dropzoneSortables = dropzoneSortables;
    }
    destroy(){
        this.leftSortable.destroy();
        this.dropzoneSortables.map((sortable) => {
            sortable.destroy();
        });
    }
};
export { FormBuilder };
export default FormBuilder;